import type { Tenants } from '@gp/base'

import { apiClient } from '@/api/client'
import { type IActivateOfferResponse } from '@/types/offer'

import type { GameIDs } from './types'

interface ActivateOfferPayload {
  tenant: Tenants
  timeZone: string
  gameId?: GameIDs
}

export const activateOffer = async ({
  tenant,
  timeZone,
  gameId = 'esum',
}: ActivateOfferPayload): Promise<IActivateOfferResponse> => {
  const queryParams = new URLSearchParams({
    network: tenant,
    time_zone: timeZone,
  })

  const response = await apiClient.instance.post<IActivateOfferResponse>(
    `/v1/${gameId}/offer/activate?${queryParams.toString()}`,
  )
  return response.data
}
